/* eslint-disable jsx-a11y/anchor-is-valid */
import { Stack } from 'react-bootstrap'
import globalUITexts from '../../../../../utils/GlobalUITexts.json'
const Step6 = ({ data, updateData }: any) => {
  return (
    <>
      <div data-kt-stepper-element='content' style={{ height: '435px', overflow: 'scroll' }}>
        <div>
          <h4 className='fs-5 fw-bold mb-2'>Features</h4>
          <Stack direction='vertical'>
            <div className='form-check form-check-custom form-check-solid mt-7'>
              <input
                className='form-check-input me-2'
                type='checkbox'
                checked={data.clientSettings.googleSearch}
                onChange={() => {
                  updateData({
                    clientSettings: {
                      ...data.clientSettings,
                      googleSearch: !data.clientSettings.googleSearch,
                    },
                  })
                }}
                id='flexCheckDefaultEDI'
              />
              <label className='form-check-label fs-5' htmlFor='flexCheckDefaultEDI'>
                Google type ahead search
              </label>
            </div>
            <div className='form-check form-check-custom form-check-solid mt-7'>
              <input
                className='form-check-input me-2'
                type='checkbox'
                checked={data.clientSettings.billImages}
                onChange={() => {
                  updateData({
                    clientSettings: {
                      ...data.clientSettings,
                      billImages: !data.clientSettings.billImages,
                    },
                  })
                }}
                id='flexCheckDefaultEDI'
              />
              <label className='form-check-label fs-5' htmlFor='flexCheckDefaultEDI'>
                Customer bill images
              </label>
            </div>
            <div className='form-check form-check-custom form-check-solid mt-7'>
              <input
                className='form-check-input me-2'
                type='checkbox'
                checked={data.clientSettings.billUploadOnlyByCamera}
                onChange={() => {
                  updateData({
                    clientSettings: {
                      ...data.clientSettings,
                      billUploadOnlyByCamera: !data.clientSettings.billUploadOnlyByCamera,
                    },
                  })
                }}
                disabled={!data.clientSettings.billImages}
                id='flexCheckDefaultEDI'
              />
              <label className='form-check-label fs-5' htmlFor='flexCheckDefaultEDI'>
                Bill Upload Only By Camera
              </label>
            </div>
            <div className='form-check form-check-custom form-check-solid mt-7'>
              <input
                className='form-check-input me-2'
                type='checkbox'
                checked={data.clientSettings.transcribedResponse}
                onChange={() => {
                  updateData({
                    clientSettings: {
                      ...data.clientSettings,
                      transcribedResponse: !data.clientSettings.transcribedResponse,
                    },
                  })
                }}
                id='flexCheckDefaultEDI'
              />
              <label className='form-check-label fs-5' htmlFor='flexCheckDefaultEDI'>
                Display transcribed responses (Yes/No prompts)
              </label>
            </div>
            <div className='form-check form-check-custom form-check-solid mt-7'>
              <input
                className='form-check-input me-2'
                type='checkbox'
                checked={data.clientSettings.liveAgents}
                onChange={() => {
                  updateData({
                    clientSettings: {
                      ...data.clientSettings,
                      liveAgents: !data.clientSettings.liveAgents,
                    },
                  })
                }}
                id='flexCheckDefaultEDI'
              />
              <label className='form-check-label fs-5' htmlFor='flexCheckDefaultEDI'>
                {globalUITexts.FEATURE_FLAGS_UI.liveAgent}
              </label>
            </div>
            <div className='form-check form-check-custom form-check-solid mt-7'>
              <input
                className='form-check-input me-2'
                type='checkbox'
                checked={data.clientSettings.liveAgentCustomerDetailsEditable}
                onChange={() => {
                  updateData({
                    clientSettings: {
                      ...data.clientSettings,
                      liveAgentCustomerDetailsEditable:
                        !data.clientSettings.liveAgentCustomerDetailsEditable,
                    },
                  })
                }}
                id='flexCheckDefaultEDI'
              />
              <label className='form-check-label fs-5' htmlFor='flexCheckDefaultEDI'>
                Live Agent can edit customer details
              </label>
            </div>
            <div className='form-check form-check-custom form-check-solid mt-7'>
              <input
                className='form-check-input me-2'
                type='checkbox'
                checked={data.clientSettings.smsTPV}
                onChange={() => {
                  updateData({
                    clientSettings: {
                      ...data.clientSettings,
                      smsTPV: !data.clientSettings.smsTPV,
                    },
                  })
                }}
                id='flexCheckDefaultEDI'
              />
              <label className='form-check-label fs-5' htmlFor='flexCheckDefaultEDI'>
                {globalUITexts.FEATURE_FLAGS_UI.textTpv}
              </label>
            </div>
            <div className='form-check form-check-custom form-check-solid mt-7'>
              <input
                className='form-check-input me-2'
                type='checkbox'
                checked={data.clientSettings.smsD2D}
                onChange={() => {
                  updateData({
                    clientSettings: {
                      ...data.clientSettings,
                      smsD2D: !data.clientSettings.smsD2D,
                    },
                  })
                }}
                id='flexCheckDefaultEDI'
              />
              <label className='form-check-label fs-5' htmlFor='flexCheckDefaultEDI'>
                {globalUITexts.FEATURE_FLAGS_UI.smsD2D}
              </label>
            </div>
            <div className='form-check form-check-custom form-check-solid mt-7'>
              <input
                className='form-check-input me-2'
                type='checkbox'
                checked={data.clientSettings.emailD2D}
                onChange={() => {
                  updateData({
                    clientSettings: {
                      ...data.clientSettings,
                      emailD2D: !data.clientSettings.emailD2D,
                    },
                  })
                }}
                id='flexCheckDefaultEDI'
              />
              <label className='form-check-label fs-5' htmlFor='flexCheckDefaultEDI'>
                {globalUITexts.FEATURE_FLAGS_UI.emailD2D}
              </label>
            </div>
            <div className='form-check form-check-custom form-check-solid mt-7'>
              <input
                className='form-check-input me-2'
                type='checkbox'
                disabled={!(data.clientSettings.smsD2D || data.clientSettings.emailD2D)}
                checked={data?.clientSettings?.enableContractRequired}
                onChange={() => {
                  updateData({
                    clientSettings: {
                      ...data.clientSettings,
                      enableContractRequired: !data.clientSettings.enableContractRequired,
                    },
                  })
                }}
                id='flexCheckDefaultEDI'
              />
              <label className='form-check-label fs-5' htmlFor='flexCheckDefaultEDI'>
                {globalUITexts.FEATURE_FLAGS_UI.enableContractRequired}
              </label>
            </div>
            <div className='form-check form-check-custom form-check-solid mt-7'>
              <input
                className='form-check-input me-2'
                type='checkbox'
                checked={data.clientSettings.outboundLiveAgent}
                onChange={() => {
                  updateData({
                    clientSettings: {
                      ...data.clientSettings,
                      outboundLiveAgent: !data.clientSettings.outboundLiveAgent,
                    },
                  })
                }}
                id='flexCheckDefaultEDI'
              />
              <label className='form-check-label fs-5' htmlFor='flexCheckDefaultEDI'>
                {globalUITexts.FEATURE_FLAGS_UI.outboundLiveAgent}
              </label>
            </div>

            <div className='form-check form-check-custom form-check-solid mt-7'>
              <input
                className='form-check-input me-2'
                type='checkbox'
                checked={data.clientSettings.enableApiCheck}
                onChange={() => {
                  updateData({
                    clientSettings: {
                      ...data.clientSettings,
                      enableApiCheck: !data.clientSettings.enableApiCheck,
                    },
                  })
                }}
                id='flexCheckDefaultEDI'
              />
              <label className='form-check-label fs-5' htmlFor='flexCheckDefaultEDI'>
                Check for existing customer in API
              </label>
            </div>
            <div className='form-check form-check-custom form-check-solid mt-7'>
              <input
                className='form-check-input me-2'
                type='checkbox'
                checked={data.clientSettings.enableDynamicProductCreation}
                onChange={() => {
                  updateData({
                    clientSettings: {
                      ...data.clientSettings,
                      enableDynamicProductCreation:
                        !data.clientSettings.enableDynamicProductCreation,
                    },
                  })
                }}
                id='flexCheckDefaultEDI'
              />
              <label className='form-check-label fs-5' htmlFor='flexCheckDefaultEDI'>
                Include Dynamic product template
              </label>
            </div>
            <div className='form-check form-check-custom form-check-solid mt-7'>
              <input
                className='form-check-input me-2'
                type='checkbox'
                checked={data.clientSettings.enableContractStartDate}
                onChange={() => {
                  updateData({
                    clientSettings: {
                      ...data.clientSettings,
                      enableContractStartDate: !data.clientSettings.enableContractStartDate,
                    },
                  })
                }}
                id='flexCheckDefaultEDI'
              />
              <label className='form-check-label fs-5' htmlFor='flexCheckDefaultEDI'>
                Include Contract Start date
              </label>
            </div>
            <div className='form-check form-check-custom form-check-solid mt-7'>
              <input
                className='form-check-input me-2'
                type='checkbox'
                checked={data.clientSettings.isUtilityMeterNumberRequired}
                onChange={() => {
                  updateData({
                    clientSettings: {
                      ...data.clientSettings,
                      isUtilityMeterNumberRequired:
                        !data.clientSettings.isUtilityMeterNumberRequired,
                    },
                  })
                }}
                id='flexCheckDefaultEDI'
              />
              <label className='form-check-label fs-5' htmlFor='flexCheckDefaultEDI'>
                Include Meter ID
              </label>
            </div>

            <div className='form-check form-check-custom form-check-solid mt-7'>
              <input
                className='form-check-input me-2'
                type='checkbox'
                checked={data.clientSettings.disableExistingCustomerEnrollment}
                onChange={() => {
                  updateData({
                    clientSettings: {
                      ...data.clientSettings,
                      disableExistingCustomerEnrollment:
                        !data.clientSettings.disableExistingCustomerEnrollment,
                    },
                  })
                }}
                id='flexCheckDefaultEDI'
              />
              <label className='form-check-label fs-5' htmlFor='flexCheckDefaultEDI'>
                Remove ability to Enroll Existing Customer
              </label>
            </div>
            <div className='form-check form-check-custom form-check-solid mt-7'>
              <input
                className='form-check-input me-2'
                type='checkbox'
                checked={data.clientSettings.enableLineTypeIntelligence}
                onChange={() => {
                  updateData({
                    clientSettings: {
                      ...data.clientSettings,
                      enableLineTypeIntelligence: !data.clientSettings.enableLineTypeIntelligence,
                    },
                  })
                }}
                id='flexCheckDefaultEDI'
              />
              <label className='form-check-label fs-5' htmlFor='flexCheckDefaultEDI'>
                Include Phone line type
              </label>
            </div>
            <div className='form-check form-check-custom form-check-solid mt-7'>
              <input
                className='form-check-input me-2'
                type='checkbox'
                checked={data.clientSettings.enableNoTPV}
                onChange={() => {
                  updateData({
                    clientSettings: {
                      ...data.clientSettings,
                      enableNoTPV: !data.clientSettings.enableNoTPV,
                    },
                  })
                }}
                id='flexCheckDefaultEDI'
              />
              <label className='form-check-label fs-5' htmlFor='flexCheckDefaultEDI'>
                No tpv
              </label>
            </div>
            <div className='form-check form-check-custom form-check-solid mt-7'>
              <input
                className='form-check-input me-2'
                type='checkbox'
                checked={data.clientSettings.enableZipCodeInUtility}
                onChange={() => {
                  updateData({
                    clientSettings: {
                      ...data.clientSettings,
                      enableZipCodeInUtility: !data.clientSettings.enableZipCodeInUtility,
                    },
                  })
                }}
                id='flexCheckDefaultEDI'
              />
              <label className='form-check-label fs-5' htmlFor='flexCheckDefaultEDI'>
                Enable ZipCode In Utility
              </label>
            </div>

            <div className='form-check form-check-custom form-check-solid mt-7'>
              <input
                className='form-check-input me-2'
                type='checkbox'
                checked={data.clientSettings.enableCustomerReportToSalesChannel}
                onChange={() => {
                  updateData({
                    clientSettings: {
                      ...data.clientSettings,
                      enableCustomerReportToSalesChannel:
                        !data.clientSettings.enableCustomerReportToSalesChannel,
                    },
                  })
                }}
                id='flexCheckDefaultEDI'
              />
              <label className='form-check-label fs-5' htmlFor='flexCheckDefaultEDI'>
                Enable Customer Report To SalesChannel
              </label>
            </div>
            <div className='form-check form-check-custom form-check-solid mt-7'>
              <input
                className='form-check-input me-2'
                type='checkbox'
                checked={data.clientSettings.enableTelephoneViewForSalesAdmin}
                onChange={() => {
                  updateData({
                    clientSettings: {
                      ...data.clientSettings,
                      enableTelephoneViewForSalesAdmin:
                        !data.clientSettings.enableTelephoneViewForSalesAdmin,
                    },
                  })
                }}
                id='flexCheckDefaultEDI'
              />
              <label className='form-check-label fs-5' htmlFor='flexCheckDefaultEDI'>
                Enable Telephone Number View for SalesChannel
              </label>
            </div>

            <div className='form-check form-check-custom form-check-solid mt-7'>
              <input
                className='form-check-input me-2'
                type='checkbox'
                checked={data.clientSettings.enableMultipleUan}
                onChange={() => {
                  updateData({
                    clientSettings: {
                      ...data.clientSettings,
                      enableMultipleUan:
                        !data.clientSettings.enableMultipleUan,
                    },
                  })
                }}
                id='flexCheckDefaultMuan'
              />
              <label className='form-check-label fs-5' htmlFor='flexCheckDefaultMuan'>
                Enable Multiple Enrollments
              </label>

            </div>
            <div className='form-check form-check-custom form-check-solid mt-7'>
              <input
                className='form-check-input me-2'
                type='checkbox'
                checked={data.clientSettings.enableKaptureCrm}
                onChange={() => {
                  updateData({
                    clientSettings: {
                      ...data.clientSettings,
                      enableKaptureCrm:
                        !data.clientSettings.enableKaptureCrm,
                    },
                  })
                }}
                id='flexKaptureCrm'
              />
              <label className='form-check-label fs-5' htmlFor='flexKaptureCrm'>
                Enable Kapture Crm
              </label>

            </div>
            <div className='mt-7'>
              <label className='fs-5 fs-5 fw-bold mb-2'>Opt-in message for contract</label>
              <textarea
                name='businessDescription'
                className='form-control form-control-lg form-control-solid resize-none min-h-300px'
                value={data.optInMessage}
                placeholder='Enter Opt-in text'
                maxLength={2000}
                onChange={(e) => {
                  updateData({
                    optInMessage: e.target.value,
                  })
                }}
                rows={2}
              ></textarea>
            </div>
            <div className='mt-7'>
              <label className='fs-5 fs-5 fw-bold mb-2'>Outbound Live Agent Fail Script</label>
              <textarea
                name='businessDescription'
                className='form-control form-control-lg form-control-solid resize-none min-h-300px'
                value={data.outboundLiveAgentFailMsg}
                placeholder='Enter  Outbound Live Agent Fail Script'
                maxLength={2000}
                onChange={(e) => {
                  updateData({
                    outboundLiveAgentFailMsg: e.target.value,
                  })
                }}
                rows={2}
              ></textarea>
            </div>
          </Stack>
        </div>
      </div>
    </>
  )
}

export { Step6 }
